var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PropTypes } from 'react';

var FormLabel = function (_React$Component) {
  _inherits(FormLabel, _React$Component);

  function FormLabel() {
    _classCallCheck(this, FormLabel);

    return _possibleConstructorReturn(this, (FormLabel.__proto__ || Object.getPrototypeOf(FormLabel)).apply(this, arguments));
  }

  _createClass(FormLabel, [{
    key: 'render',
    value: function render() {
      var className = 'cf-form__label';

      if (this.props.hidden) {
        className += ' cf-form__label--hidden';
      }

      return React.createElement(
        'label',
        { className: className },
        this.props.children
      );
    }
  }]);

  return FormLabel;
}(React.Component);

FormLabel.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node
};

export default FormLabel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-form/es/FormLabel.js
// module id = 1025
// module chunks = 0